export default {
    helpText: 'Letters, digits and ./+/-/_ only.',
    label: 'Username',
    title: 'Change Username',
};
